const features_and_bugs_tour = {
	features_bugs_tour_steps: {
		bug_button: {
			description: "Heb je een bug gevonden? Laat het ons weten via deze knop.",
			title: "Een bug gevonden?",
		},
		bug_text: {
			description: "Hier zie je bugs die door anderen zijn gevonden.",
			title: "Rapporttekst",
		},
		features_button: {
			description: "Hier kun je je eigen functieverzoek maken.",
			title: "Je eigen verzoek?",
		},
		features_text: {
			description: "Dit zijn verzoeken om onze website te verbeteren.",
			title: "Aangevraagde features",
		},
	},

	features_dialog_tour_steps: {
		description_bug: {
			description: "Hier schrijf je een beschrijving op om ons te laten weten wat je wilt.",
			title: "Geef ons een beschrijving",
		},
		title_bug: {
			description: "Hier schrijf je de titel van je verzoek op.",
			title: "Titel",
		},
		upload_bug: {
			description:
				"Hier kun je een schermafbeelding uploaden. Klik in het midden en kies het bestand dat je wilt uploaden.",
			title: "uploaden",
		},
	},
};
export default features_and_bugs_tour;
